export default {"src":"/_next/static/media/trustpilot-logo.926fec93.svg","height":58,"width":61,"blurWidth":0,"blurHeight":0};